import { createSlice } from '@reduxjs/toolkit';
import REDUX_SLICE_NAMES from 'consts/redux-slice-names';
import { useAppDispatch, useAppSelector } from '../hooks';
import { RootState } from '../store';

interface AccordionModel {
    itemAccordionOutermost: string;
    itemAccordion: string;
    itemAccordionTree: string;
    selectItemAccordion?: any;
    isOpenAccordion:boolean;
}

const initialState : AccordionModel = {
  itemAccordionOutermost: '',
  itemAccordion: '',
  itemAccordionTree: '',
  selectItemAccordion: {},
  isOpenAccordion:false
};

export const accordionSlice = createSlice({
    name: REDUX_SLICE_NAMES.ACCORDION,
    initialState,
    reducers: {
      setAccordionState: (state: AccordionModel = initialState, action) => {
        const listProperties = Object.keys(state);
        Object.keys(action.payload).forEach((field) => {
          if (listProperties.includes(field)) {
            state[field as keyof AccordionModel] = action.payload[field as keyof AccordionModel] as never;
          }
        });
      },
      setIsOpenAccordion: (state, action) =>{
        state.isOpenAccordion=action.payload
      }
    },
  });
  
  const { setAccordionState,setIsOpenAccordion } = accordionSlice.actions;
  
  export const useGetAccordionState = () => useAppSelector((state: RootState) => state[accordionSlice.name]) as AccordionModel;
  export const useSetIsOpenAccordion = () =>{
    const dispatch = useAppDispatch();
    return {
        setIsOpenAcc: (isOpen:boolean)=>{
          dispatch(setIsOpenAccordion(isOpen))
        }
    };
  }
  export const useSetCustomAccordionState = () => {
    const dispatch = useAppDispatch();
    return {
        setAccordionField: (fields: Partial<AccordionModel>) => {
            dispatch(setAccordionState(fields));
          },
    };
  };
  
  export default accordionSlice;
